export const NAME = 'create-attachment-modal';
